import CryptoJS from 'crypto-js'
import { tripledesKey, tripledesIv } from '@/config/env'

export function tripleDesEncode(value){
    const code = CryptoJS.TripleDES.encrypt(value , tripledesKey , {
        iv: tripledesIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString()
    return code
}